// GENERATED FILE, PLEASE DO NOT EDIT
var ButtonToggleGroup = 'Rectangle';
var ButtonDefault = 'Rectangle';
var ShapeSemanticsAll = {
  ButtonDefault: ButtonDefault,
  ButtonToggleGroup: ButtonToggleGroup
};

export { ButtonDefault, ButtonToggleGroup, ShapeSemanticsAll, ShapeSemanticsAll as default };
